import React, { useState } from "react";
import {
  FaTimes,
  FaCopy,
  FaSyncAlt,
} from "react-icons/fa";

const ResetPasswordModal = ({user,onClose,}) => {

  const generatePassword = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$%";
    let password = "";

    for (let i = 0;i < 10;i++) {
      password += chars.charAt(
          Math.floor(
            Math.random() * chars.length)
        );
    }
    return password;
  };

  const [password,setPassword] = useState(generatePassword());

  const [saving,setSaving] = useState(false);

  const copyPassword = () => {
    navigator.clipboard.writeText(password);
    alert("Password copied to clipboard");
  };

  const resetPassword = async () => {
      try {
        setSaving(true);
        const response = await fetch(`${process.env.REACT_APP_FORE_APILINK}user/reset-password`,
          {
            method:"PUT",
            headers:{
              "Content-Type":
              "application/json"
            },
            body:JSON.stringify({
              user_id:user._id,
              password,
              forcePasswordChange:true
            })
          }
        );

        const result = await response.json();

        if(!response.ok){
          throw new Error(result.message);
        }

        alert("Password Reset Successfully");
        onClose();

      }
      catch(error){
        alert(error.message);
      }
      finally{
        setSaving(false);
      }
    };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-full max-w-md rounded-xl bg-white p-6">
        <div className="mb-5 flex items-center justify-between">
          <h2 className="text-xl font-semibold">
            Reset Password
          </h2>

          <button onClick={onClose}>
            <FaTimes/>
          </button>
        </div>

        <div className="mb-4">
          <label className="mb-2 block font-medium">
            User
          </label>

          <input
            value={user?.username}
            readOnly
            className="w-full rounded border bg-gray-100 px-3 py-2"
          />
        </div>

        <div className="mb-5">
          <label className="mb-2 block font-medium">
            Temporary Password
          </label>

          <div className="flex">
            <input
              value={password}
              readOnly
              className="flex-1 rounded-l border px-3 py-2"
            />

            <button
              onClick={copyPassword}
              className="border px-4"
            >
              <FaCopy/>
            </button>

            <button
              onClick={()=> setPassword(generatePassword())}
              className="rounded-r border px-4"
            >
              <FaSyncAlt/>
            </button>
          </div>
        </div>

        <div className="rounded-lg bg-yellow-50 p-3 text-sm text-yellow-700">
          The user will be required to change their password on their next login.
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="rounded border px-4 py-2"
          >
            Cancel
          </button>

          <button
            onClick={resetPassword}
            disabled={saving}
            className="rounded bg-[#F7525A] px-5 py-2 text-white"
          >
            {saving ? "Resetting..."  : "Reset Password"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordModal;